module.exports={
  "id": "decadent-displays",
  "name": "Decadent displays",
  "badge": "Custom tablescapes",
  "subtext": "These beautifully arranged selections are as much of a feast for the eyes as for the taste buds.",
  "coverImage": "https://img.peerspace.com/image/upload/v1725383524/0sqmzxcr8daiku9ahok4.jpg",
  "price": {
    "value": 28.0,
    "per_person": true,
    "starts_at": true
  },
  "menu": {
    "subtext": "Includes setup, breakdown and equipment rental. You’ll need to provide the table(s), and we’ll provide everything else including decor, risers, florals, faux candles, and boards.",
    "menu_sections": [
      {
        "id": "decadent-displays-selections",
        "title": "Select your display(s)",
        "min_selections": 1,
        "max_selections": 3,
        "items": [
          {
            "name": "Charcuterie",
            "description": "Premium cheeses and charcuterie meats, fresh fruits and crudité, dessert bites and accompaniments.",
            "price": {
              "value": 0.0
            },
            "sizes": [
              {
                "name": "20+ guests",
                "price": {
                  "value": 1625.0
                }
              },
              {
                "name": "30+ guests",
                "price": {
                  "value": 1875.0
                }
              },
              {
                "name": "40+ guests",
                "price": {
                  "value": 2125.0
                }
              },
              {
                "name": "50+ guests",
                "price": {
                  "value": 2499.0
                }
              },
              {
                "name": "60+ guests",
                "price": {
                  "value": 2999.0
                }
              }
            ]
          },
          {
            "name": "Sweets",
            "description": "Macarons, cookies, cake parfaits, doughnuts, candy jars, chocolate covered strawberries, cheesecakes, tiramisu cups, and more.",
            "price": {
              "value": 0.0
            },
            "sizes": [
              {
                "name": "30+ guests",
                "price": {
                  "value": 1375.0
                }
              },
              {
                "name": "50+ guests",
                "price": {
                  "value": 1689.0
                }
              },
              {
                "name": "75+ guests",
                "price": {
                  "value": 2065.0
                }
              }
            ]
          },
          {
            "name": "Brunch",
            "description": "Fresh bagels, smoked salmon, croissants, scones, danishes, fruit, cheese, charcuterie and more.",
            "price": {
              "value": 0.0
            },
            "sizes": [
              {
                "name": "20+ guests",
                "price": {
                  "value": 1625.0,
                  "per_person": false
                }
              },
              {
                "name": "30+ guests",
                "price": {
                  "value": 1875.0,
                  "per_person": false
                }
              },
              {
                "name": "40+ guests",
                "price": {
                  "value": 2125.0,
                  "per_person": false
                }
              },
              {
                "name": "50+ guests",
                "price": {
                  "value": 2499.0,
                  "per_person": false
                }
              },
              {
                "name": "60+ guests",
                "price": {
                  "value": 2999.0,
                  "per_person": false
                }
              }
            ]
          }
        ]
      }
    ]
  },
  "description": "Includes setup, breakdown and equipment rental. You provide the table(s), and we’ll provide everything else including decor, risers, florals, faux candles, and boards."
}
